import type { IDropdownStyles } from '@fluentui/react';

export const dropDownStyles: Partial<IDropdownStyles> = {
    dropdown: {
        height: '28px',
        fontSize: '12px',
        position: 'relative',
        borderColor: '#c8c8c8',
    },
    dropdownItem: {
        fontSize: '12px',
    },
    dropdownItemSelected: {
        fontSize: '12px',
    },
    title: {
        height: '30px',
    },
    root: {
        fontSize: '12px',
        height: '30px',
    },
};

export const labelStyles: Partial<IDropdownStyles> = {
    root: {
        display: 'contents',
    },
};
